import React, { useState } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import JobPreferencesModal from "../Common_profile_details_modals/JobPreferencesModal/JobPreferencesModal";

function JobPreferencesCard() {
  const [showJobPreferenceModal, setShowJobPreferenceModal] = useState(false);

  const handleOpenModal = () => {
    setShowJobPreferenceModal(true);
  };

  const handleCloseModal = () => {
    setShowJobPreferenceModal(false);
  };

  return (
    <>
      <Card className="profile-card-pattern">
        <Card.Body className="profile-card-pattern__body">
          <div className="profile-card-pattern__header">
            <Card.Title className="profile-card-pattern__title">
              Job preferences
            </Card.Title>

            <Button
              variant="link"
              className="profile-card-pattern__btn-edit"
              aria-label="Edit job preferences"
              onClick={handleOpenModal}
            >
              <span className="summary-card__edit-icon">✏️</span>
            </Button>
          </div>

          <Row className="g-3">
            <Col xs={12} className="profile-pattern-detail-cell">
              <span className="profile-pattern-detail-cell__label">
                Preferred Job Title
              </span>
              <span className="profile-pattern-detail-cell__value">
                React.js Developer
              </span>
            </Col>

            <Col xs={12} className="profile-pattern-detail-cell">
              <span className="profile-pattern-detail-cell__label">
                Preferred Location
              </span>
              <span className="profile-pattern-detail-cell__value">
                Nagpur
              </span>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Job Preferences Modal */}
      <JobPreferencesModal
        show={showJobPreferenceModal}
        handleClose={handleCloseModal}
      />
    </>
  );
}

export default JobPreferencesCard;